import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'article' | 'header';
};
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as];
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-36" data-mp="3gfe3jberaq43">
      {children}
    </MotionTag>;
}